import {IModularHouseBoosterParams} from "../types/booster_generic/IModularHouseBooster";
import {IBoosterCategory} from "../types/IBoosterCategory";
import {IGenericBoostersConfig} from "../types/IGenericBoostersConfig";
import {modularHouseBDIncreasedInterestBooster} from "./modular_house/modular_house_bd_increased_interest_booster";
import {modularHouseBDViewsLast3daysBooster} from "./modular_house/modular_house_bd_views_last_3days_booster";

export const modularHouseBoostersConfig: IGenericBoostersConfig<IModularHouseBoosterParams> = {
    [IBoosterCategory.Promotion]: {},
    [IBoosterCategory.OfferStats]: {},
    [IBoosterCategory.BigDataStats]: {
        [modularHouseBDIncreasedInterestBooster.type]: modularHouseBDIncreasedInterestBooster,
        [modularHouseBDViewsLast3daysBooster.type]: modularHouseBDViewsLast3daysBooster
    }
};
import {IModularHouseBoosterParams} from "../types/booster_generic/IModularHouseBooster";
import {IBoosterCategory} from "../types/IBoosterCategory";
import {IGenericBoostersConfig} from "../types/IGenericBoostersConfig";
import {modularHouseBDIncreasedInterestBooster} from "./modular_house/modular_house_bd_increased_interest_booster";
import {modularHouseBDViewsLast3daysBooster} from "./modular_house/modular_house_bd_views_last_3days_booster";

export const modularHouseBoostersConfig: IGenericBoostersConfig<IModularHouseBoosterParams> = {
    [IBoosterCategory.Promotion]: {},
    [IBoosterCategory.OfferStats]: {},
    [IBoosterCategory.BigDataStats]: {
        [modularHouseBDIncreasedInterestBooster.type]: modularHouseBDIncreasedInterestBooster,
        [modularHouseBDViewsLast3daysBooster.type]: modularHouseBDViewsLast3daysBooster
    }
};
